class Phone {
	static FormatNumber(num) {
		let p = String(num || '');
		if(p.length === 10){
			p = `(${p.substring(0, 3)}) ${p.substring(3, 6)}-${p.substring(6, 10)}`
		}
		return p;
	}
}

export default class Helper {
	static Phone = Phone;
}



// WEBPACK FOOTER //
// ./src/classes/Helper.js